// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './vinhetas.scss';

//Utils
import { PRODUCT_KEY_VINHETAS_FORMAT, PRODUCT_KEY_VINHETAS_PACKS, VINHETAS_PAPEL_PRODUCT } from '../../../common/constants';

// Redux
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';

class VinhetasComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            packs: 1,
            validPacks: true
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        if(this.validateForm()) {
            let metadata = [
                { key: PRODUCT_KEY_VINHETAS_FORMAT, value: this.props.format },
                { key: PRODUCT_KEY_VINHETAS_PACKS, value: this.state.packs.toString() }
            ];

            // Add product to basket
            let product = this.props.product;
            product.metadata = metadata;
            product.price *= this.state.packs;
            product.title = this.state.packs.toString() + "x " + this.props.t("products.products." + product.title);

            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
            }

            products.push(product);

            this.props.updateBasket(products, this.props.basketTrainings);
            this.props.onClose();
        }
    }

    validateForm() {
        this.setState({
            validPacks: this.state.packs >= 1
        });

        let validationResult = (this.state.packs >= 1);

        return validationResult;
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                    <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.vinhetas-pack")}</li>
                    <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.vinhetas-minimum")}</li>
                    {
                        this.props.product.productRef === VINHETAS_PAPEL_PRODUCT ?
                        <>
                            <li>{this.props.t("products.labels.vinhetas-address")}</li>
                        </>
                        :
                        null
                    }
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="ticket-number">{this.props.t("products.labels.pack-number")}</label>
                        <InputText value={this.state.packs} id="ticket-number" type="number" min={1} onChange={(evt) => this.updateFormComponent("packs", evt.target.value)} />
                        { this.state.validPacks ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() } />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(VinhetasComponent));